module.exports = new __parcel__URL__("backlog-preview-dark.d971d34f.svg").toString();